{
  "error": "Erreur",
  "help": "Aide",
  "info": "Informations",
  "success": "Succès",
  "warning": "Avertissement"
}
